var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPrivacy = function SvgPrivacy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 45 45"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "Privacy_svg__a",
    width: 45,
    height: 45,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h45v45H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#022356",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    mask: "url(#Privacy_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    d: "m35.684 3.955-2.637-2.637H11.953L9.316 3.955H4.043v15.17c0 11.362 7.532 21.383 18.457 24.504 10.925-3.121 18.457-13.142 18.457-24.504V3.955h-5.273Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Privacy_svg__b)",
    d: "M22.5 33.047a7.91 7.91 0 0 1-7.91-7.91v-7.91h15.82v7.91a7.91 7.91 0 0 1-7.91 7.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.227 17.227v-5.362a5.273 5.273 0 0 1 10.546 0v5.362M22.5 21.182v7.91"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Privacy_svg__b",
    x1: 14.5,
    x2: 30,
    y1: 17.5,
    y2: 32.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2561"
  })))));
};
export default SvgPrivacy;